import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "./assets/estilo.css"
import axios from "axios"
import { BSpinner } from 'bootstrap-vue'
import VueAnalytics from 'vue-ua'

Vue.use(BootstrapVue)
Vue.use(axios)
Vue.component('b-spinner', BSpinner)
Vue.use(VueAnalytics,{
  appName:'Consulta de datos',
  appVersion:'1.0',
  trackingId:'UA-45355240-1'
})

new Vue({
  el: '#app',
  render: h => h(App)
})
